'use strict';

import ngResource from 'angular-resource';

function MonthlyGroupActivePowerService ($resource) {
    return $resource(
        '/api/monthly_group_active_power/:id', { id: '@id' },
        { 
            show : { method: 'GET', isArray: false }
        }
    )
}

export default angular.module('leptonApp.MonthlyGroupActivePowerService', ['ngResource'])
    .factory('MonthlyGroupActivePowerService', ['$resource', MonthlyGroupActivePowerService])
    .name;



// WEBPACK FOOTER //
// ./public/dev/components/api/monthly_group_active_power/monthly_group_active_power.service.js